import {
  DialogActions,
  DialogContent,
  Typography,
  useEventCallback,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { Box } from '@mui/system';
import { AxiosPromise } from 'axios';
import React from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { PmiDialog } from 'shell/components/shared/dialog';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  reprint: () => void;
}

function PrintSuccessModal({ isOpen, onClose, reprint }: SuccessModalProps): React.ReactElement {
  const registerOperation = useHttpClient(`${__PRACTICE_API_URL__}/registra-operazione`, {
    options: {
      errorCatching: true,
      method: 'POST',
      loading: true,
      data: {},
    },
  });

  const params = useParams();
  const confirmOperation = useEventCallback(() => {
    (
      registerOperation({
        data: {
          codiceEnte: params?.codiceEnte || undefined,
          tipoRegistro: params?.tipoRegistro || undefined,
          idAnnoPratica: params?.idAnnoPratica
            ? Number.parseInt(params?.idAnnoPratica, 10)
            : undefined,
          progressivoPratica: params?.progressivoPratica
            ? Number.parseInt(params?.progressivoPratica, 10)
            : undefined,
          codiceSospensione: 0,
          tipoOperazione: '75',
          tipoPratica: params.tipoPratica || undefined,
          tipoStatoPratica: '4',
        },
      }) as AxiosPromise<void>
    ).then(() => {
      toast.success('Operazione eseguita con successo');
      onClose();
    });
  });

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      fullScreen={fullScreen}
      open={isOpen}
      onClose={onClose}
      aria-labelledby="close-modal"
      aria-describedby="close-modal"
    >
      <DialogContent style={{ padding: '30px 24px' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography gutterBottom component="h2">
            La stampa del documento è stata effettuata con successo?
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <PmiButton variant="contained" color="cdmBrand" type="button" onClick={confirmOperation}>
          Conferma
        </PmiButton>
        <PmiButton variant="outlined" color="primary" type="button" onClick={reprint}>
          Ristampa
        </PmiButton>
        <PmiButton variant="outlined" color="primary" type="button" onClick={onClose}>
          Annulla
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
}

PrintSuccessModal.displayName = 'Print Success Modal component';
export default PrintSuccessModal;
